import { render, staticRenderFns } from "./IconMenuDropdown.vue?vue&type=template&id=7df53c12&"
import script from "./IconMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./IconMenuDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports